module.exports = __webpack_public_path__ + "fib.svg?9b8b633cc3128ce02ab7e0f2e967dd8a";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fib.svg
// module id = 293
// module chunks = 0